export const iconFontAwesomeGamingDice = (
	<i className="fa-solid fa-dice"></i>
);
